import { PasswordForm } from "./AdminResetPassword";

export default function AdminSetPassword() {
  return (
    <PasswordForm
      endpoint="/auth/set-password"
      title="Welcome to the editorial desk"
      blurb="Choose your password to activate your admin account. This link works once and expires 48 hours after it was sent."
      testid="set-password"
    />
  );
}
